<template>
  <p>
    <translate>Try widening your geographic area to:</translate
    ><pu-low-results-search-link
      v-for="hierarchy of hierarchyTrail"
      :key="hierarchy.path"
      :modify-filters="{ area: undefined }"
      :hierarchy-path="hierarchy.path"
    >
      {{ hierarchy.name }}
    </pu-low-results-search-link>
  </p>
</template>

<script lang="ts">
import { HierarchyTrail } from '../../schemas'
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class LowResultsHierarchy extends Vue {
  @Prop()
  hierarchyTrail: HierarchyTrail[]
}

export default toNative(LowResultsHierarchy)
</script>
<style scoped>
p :deep(a) {
  white-space: normal;
}
</style>
